import React from 'react';
import './Aqua.css';
import FMSimage from '../Assets/aqua11.jpg'; // First image
import FMSimage2 from '../Assets/aqua2.jpg'; // Image for Key Features & Benefits
import FMSimage3 from '../Assets/aqua4.jpeg'; // Image for How it Works section
import FMSimage4 from '../Assets/aqua4 - Copy.jpeg'; // Image for Why Choose section
import FMSimage5 from '../Assets/water2.jpg'; // Image for Industries section

const FMS = () => {
    return (
        <div className="FMS-card">
            <div className="FMS-container">
                {/* First Section: Overview */}
                <div className="FMS-content-container">
                    <div className="FMS-text">
                        <h1 className="FMS-heading">AQUA TANTRA</h1>
                        <p className="FMS-description">
                            The IoT-enabled Aqua Tantra Smart Pond Monitoring System is designed to address the high risks of aquaculture farming. With real-time monitoring capabilities, it dramatically boosts yield and productivity by providing precise data and control, ensuring optimal pond conditions for sustainable farming.
                        </p>
                    </div>
                    <div className="FMS-image-container">
                        <img src={FMSimage} alt="Aqua Tantra Monitoring" className="FMS-image" />
                    </div>
                </div>

                {/* Key Features & Benefits */}
                <div className="FMS-bottom-heading">
                    <h2 className="FMS-bottom-text">Key Features & Benefits</h2>
                </div>
                <div className="FMS-content-container">
                    {/* Left side: Text Content */}
                    <div className="FMS-text">
                        <p className="FMS-description">
                            <ul>
                                <li><strong>Real-Time pH/DO Alerts:</strong> Triggers alerts for changes in pH and Dissolved Oxygen (DO) values.</li>
                                <li><strong>Power Supply Monitoring:</strong> Tracks DG set and EB supply readiness for reliable aerator operation.</li>
                                <li><strong>Integrated Sensors:</strong> Monitors pH, DO, temperature, salinity, and ammonia in real time via mobile app.</li>
                                <li><strong>Aerator Automation:</strong> Automates aerator start/stop based on pH/DO or allows manual control from your mobile.</li>
                                <li><strong>Worker Independence:</strong> Provides direct data access, reducing reliance on farm workers.</li>
                            </ul>
                        </p>
                    </div>
                    <div className="FMS-image-container">
                        <img src={FMSimage2} alt="Key Features" className="FMS-image" />
                    </div>
                </div>

                {/* How It Works */}
                <div className="FMS-bottom-heading">
                    <h2 className="FMS-bottom-text">How It Works</h2>
                </div>
                <div className="FMS-content-container">
                    {/* Left side: Image */}
                    <div className="FMS-image-container">
                        <img src={FMSimage3} alt="How It Works" className="FMS-image" />
                    </div>
                    {/* Right side: Text Content */}
                    <div className="FMS-text">
                        <p className="FMS-description">
                            Aqua Tantra uses world-class sensors to monitor pH, Dissolved Oxygen (DO), temperature, salinity, and ammonia in real time. Data is transmitted to a mobile app, providing instant access to pond conditions. Real-time alerts for pH/DO changes ensure timely intervention, while automated or mobile-controlled aerators maintain optimal conditions, enhancing aquaculture productivity.
                        </p>
                    </div>
                </div>

                {/* Why Choose Us */}
                <div className="FMS-bottom-heading">
                    <h2 className="FMS-bottom-text">Why Choose Aqua Tantra?</h2>
                </div>
                <div className="FMS-content-container">
                    {/* Left side: Text Content */}
                    <div className="FMS-text">
                        <p className="FMS-description">
                            <ul>
                                <li><strong>Reliable Monitoring:</strong> Real-time data on pH, DO, and other parameters for precise control.</li>
                                <li><strong>Automation:</strong> Automated aerator control reduces manual effort and ensures optimal conditions.</li>
                                <li><strong>High Productivity:</strong> Boosts aquaculture yield with timely alerts and data-driven decisions.</li>
                                <li><strong>User-Friendly:</strong> Mobile app enables easy monitoring and control from anywhere.</li>
                                <li><strong>Risk Mitigation:</strong> Addresses aquaculture challenges with proactive alerts and power supply tracking.</li>
                            </ul>
                        </p>
                    </div>
                    {/* Right side: Image */}
                    <div className="FMS-image-container">
                        <img src={FMSimage4} alt="Why Choose Aqua Tantra" className="FMS-image" />
                    </div>
                </div>

                {/* Industries */}
                <div className="FMS-bottom-heading">
                    <h2 className="FMS-bottom-text">Industries We Serve</h2>
                </div>
                <div className="FMS-content-container reverse-order-last">
                    <div className="FMS-image-container">
                        <img src={FMSimage5} alt="Industries Using Aqua Tantra" className="FMS-image" />
                    </div>
                    <div className="FMS-text">
                        <p className="FMS-description">
                            Trusted by aquaculture industries:
                            <ul>
                                <li>Shrimp Farming</li>
                                <li>Fish Farming</li>
                                <li>Aquaponics</li>
                                <li>Prawn Culture</li>
                                <li>Aquaculture Research</li>
                            </ul>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FMS;